import { BORROWER_DASHBOARD_URL, BORROWER_ONBOARDING_URL } from "@common/config/environments";
import { useEffect } from "react"
import { useExchangeOAuthToken } from 'services/auth/mutations';

const OAuthWrapper = (props: any) => {
  const { execute: exchangeOAuthToken } = useExchangeOAuthToken();

  const oAuthToken = new URLSearchParams(window.location.search).get("oauth")
  const origin = new URLSearchParams(window.location.search).get("origin")
  const action = new URLSearchParams(window.location.search).get("action")

  useEffect(() => {
    if (oAuthToken) {

      if (origin === 'borrower-admin' && action === 'create-new-borrower-loan') {
        return;
      }

      exchangeOAuthToken({ token: oAuthToken })
        .then(({ data }) => {
          if (origin === 'borrower-dashboard') {
            handleSessionTransfer(data);
          } else {
            handleImpersonation(data);
          }
        })
    }
  }, [oAuthToken])

  /**
   * Handles session transfer from Dashboard to Onboarding.
   * Stores the JWT token, cleans up URL params, and reloads the page
   * so the user stays on the current route (onboarding root).
   */
  const handleSessionTransfer = (data: any) => {
    if (data) {
      const token = data.exchangeOAuthToken;
      localStorage.setItem('token', token);
      window.dispatchEvent(new Event('storage'));

      const url = new URL(window.location.href);
      url.searchParams.delete("oauth");
      url.searchParams.delete("origin");
      url.pathname = '/';
      window.history.replaceState({}, document.title, url.toString());
      window.location.reload();
    }
  }

  const handleImpersonation = (data: any) => {
    if (data) {
      localStorage.removeItem('token');
      sessionStorage.removeItem('token');

      setTimeout(() => {
        const token = data.exchangeOAuthToken;
        sessionStorage.setItem('token', token);
        const isNew = new URLSearchParams(window.location.search).get("isNew");

        if (!isNew) {
          sessionStorage.setItem('fromOAuth', 'true');
        } else {
          sessionStorage.removeItem('fromOAuth');
        }

        window.dispatchEvent(new Event('storage'));

        setTimeout(() => {
          const url = new URL(window.location.href);
          const loanId = url.searchParams.get("loanId");

          url.searchParams.delete("oauth");
          url.searchParams.delete("loanId");

          url.pathname = `/home/${loanId}`;
          window.history.replaceState({}, document.title, url.toString());
          window.location.reload();
        })

      })
    }
  }

  return (props.children)
}

export default OAuthWrapper